<div class="search-sort-container">
  <div class="search-container">
    <div class="d-flex">
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="Zoek op bedrijf"
          [(ngModel)]="companySearchTerm"
          (ngModelChange)="doSearchCompany()"
        />
      </mat-form-field>
      <button
        class="reset-button"
        (click)="resetCompanySearch()"
        [matTooltip]="'Reset zoek op bedrijf'"
        [disableRipple]="true"
        [disabled]="companySearchTerm?.length < 1"
        mat-icon-button
      >
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>

    <div class="d-flex">
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="Zoek op telefoon"
          [(ngModel)]="phoneSearchTerm"
          (ngModelChange)="doSearchPhone()"
        />
      </mat-form-field>
      <button
        class="reset-button"
        (click)="resetPhoneSearch()"
        [matTooltip]="'Reset zoek op telefoon'"
        [disableRipple]="true"
        [disabled]="phoneSearchTerm?.length < 1"
        mat-icon-button
      >
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>

    <!-- Branch Dropdown -->
    <div class="d-flex">
      <mat-form-field appearance="outline">
        <mat-label>Selecteer filiaal</mat-label>
        <mat-select
          id="branchSelect"
          [(ngModel)]="branchSearchTerm"
          (ngModelChange)="doSearchBranch()"
        >
          <mat-option *ngFor="let branch of branchList" [value]="branch.name">
            {{ branch.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button
        class="reset-button"
        (click)="resetBranchSearch()"
        [matTooltip]="'Reset zoek op filiaal'"
        [disableRipple]="true"
        [disabled]="!branchSearchTerm"
        mat-icon-button
      >
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>

    <!-- Date Dropdown -->
    <div class="d-flex">
      <mat-form-field appearance="outline">
        <input
          matInput
          [matDatepicker]="dateSearchPicker"
          placeholder="Zoek op datum"
          [(ngModel)]="dateSearch"
          (ngModelChange)="doSearchDate()"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="dateSearchPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #dateSearchPicker></mat-datepicker>
      </mat-form-field>
      <button
        class="reset-button"
        (click)="resetDateSearch()"
        [matTooltip]="'Reset zoek op datum'"
        [disableRipple]="true"
        [disabled]="dateSearch === null"
        mat-icon-button
      >
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  </div>

  <div class="checkbox-container">
    <mat-checkbox
      [(ngModel)]="sortByCompany"
      (ngModelChange)="sortByCompanyChanged()"
    >
      Op klantnaam
    </mat-checkbox>
  </div>
</div>

<ng-container *ngIf="loading; else showRecoveryStats">
  <mat-spinner color="primary" diameter="48"></mat-spinner>
</ng-container>

<ng-template #showRecoveryStats>
  <ng-container *ngIf="performanceList; else noEventsMessage">
    <app-employee-recovery-stats
      [performanceList]="performanceList"
    ></app-employee-recovery-stats>
  </ng-container>
  <ng-template #noEventsMessage>
    <div class="no-events-message">Geen recuperatie data voor deze dag</div>
  </ng-template>
</ng-template>

<div class="more-upper-space">
  <ng-container *ngIf="loading; else showRecoveryList">
    <mat-spinner color="primary" diameter="48"></mat-spinner>
  </ng-container>
  <ng-template #showRecoveryList>
    <div class="recovery-list">
      <div
        *ngFor="let item of renderedStream | async; trackBy: trackByProjectId"
        class="mb-1"
      >
        <div class="recovery-item-info">
          <span class="click-link" (click)="openRecupDetail(item)"
            >#{{ item.projectId }}</span
          >
          &nbsp;-&nbsp;
          <span>{{ item.company?.regularName }}</span>
        </div>
        <div class="recovery-item-example-container">
          <div
            *ngIf="item.exampleStyle != null"
            class="clickable recovery-item-example"
            [ngStyle]="item.exampleStyle"
            (click)="openLightbox(item.example)"
          ></div>
        </div>
        <div class="recovery-item-info">
          <div>
            <span class="strong secondary-color">{{
              item.defaultLocation
            }}</span>
            <strong *ngIf="item.placementDoneRegistrationDate"> / </strong>
            <i>{{
              item.placementDoneRegistrationDate
                | formatDate : '' : 'dd/MM/yyyy HH:mm'
            }}</i>
          </div>
          <div>
            <span class="strong" [matTooltip]="item.boardTypeDisplay">{{
              item.boardTypeDisplay | shortenText : 50
            }}</span>
            <ng-container *ngIf="item.measurements?.length > 0">
              &nbsp;-&nbsp;
              <span>{{ item.measurements }}</span>
            </ng-container>
            &nbsp;-&nbsp;
            <span>{{ item.title }}</span>
          </div>
          <ng-container
            *ngIf="!item.recoveryInProgress; else recoveryInProgress"
          >
            <div class="recovery-action-container">
              <div *ngIf="item.customBoard" class="recup-method-container">
                <span class="strong destroy-label active p-3">
                  {{ RecupMethodChoices.DESTROY.label }}
                </span>
              </div>
              <div *ngIf="!item.customBoard" class="recup-method-container">
                <mat-checkbox
                  *ngFor="let method of recupMethods"
                  [checked]="item.recupMethod?.value === method.value"
                  (click)="onRecupMethodChange(item, method, $event)"
                >
                  <span
                    [ngClass]="{
                      active: item.recupMethod?.value === method.value,
                      'recup-inactive':
                        item.recupMethod?.value !== method.value,
                      'duoprop-label': method === RecupMethodChoices.DUOPROP,
                      'destroy-label': method === RecupMethodChoices.DESTROY,
                      'kader-label': method === RecupMethodChoices.KADER
                    }"
                    class="strong"
                  >
                    {{ method.label }}
                  </span>
                </mat-checkbox>
              </div>
              <div
                class="recovery-action-button-container"
                [ngClass]="{ 'pb-2': item.customBoard }"
              >
                <button
                  class="recovery-action-button do-recover-button"
                  (click)="handleBoardRecovery(item)"
                >
                  Uitgevoerd
                </button>
              </div>
            </div>
            <div *ngIf="!item.customBoard" class="recovery-amount-container">
              <div
                class="recovery-amount-button-container no-form-field-padding"
              >
                <button
                  class="recovery-amount-button"
                  (click)="decrementRecoveryAmount(item)"
                  [disabled]="item.inputRecoveryAmount === 0"
                >
                  -
                </button>
                <div class="recovery-amount-input">
                  <input
                    [(ngModel)]="item.inputRecoveryAmount"
                    (ngModelChange)="inputRecoveryAmountChanged(item)"
                    appOnlyNumbers
                  />
                </div>
                <button
                  class="recovery-amount-button"
                  (click)="incrementRecoveryAmount(item)"
                  [disabled]="
                    item.inputRecoveryAmount >= item.suggestedRecoveryAmount
                  "
                >
                  +
                </button>
              </div>
            </div>
          </ng-container>
          <ng-template #recoveryInProgress>
            <mat-spinner color="primary" diameter="24"></mat-spinner>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-template>
</div>
